module.exports = __webpack_public_path__ + "static/img/下肢套.cb0a57f0.jpg";